import { applicationApi, loanRolesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { getConditionalObject } from 'utils/data';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectMasterCompanyId } from 'store/auth/selectors';
import { selectDealFromApplication } from 'store/loanApplications/selectors';

export const LOAN_ROLES_ACTION_TYPE_V2 = createNamedActions('loanRolesV2', {
  GET_ROLES: 'GET_ROLES',
});

export const getLoanRolesActionV2 = catchAsyncActionError(
  ({ includeDeleted = false, includes = 'PotentialUsers' } = {}) =>
    async (dispatch, getState) => {
      const companyId = selectMasterCompanyId(getState());
      const { applicationId } = selectDealFromApplication(getState());

      const { data } = await loanRolesApi.getLoanRoles({
        companyId,
        includeDeleted,
        ...getConditionalObject(includes, { includes }),
        ...getConditionalObject(applicationId, {
          forApplicationId: applicationId,
        }),
      });

      return dispatch({
        type: LOAN_ROLES_ACTION_TYPE_V2.GET_ROLES,
        payload: data,
      });
    },
);

// DEV-4826: staff a currently-unassigned loan role via the dedicated comp-free facade endpoint
// (POST application/{id}/loanRoleAssignments → CreatePotentialAssignment). Decouples broker staffing
// from the comp-validated loan-info commit so it persists even on an unpriced loan.
export const createLoanRoleAssignmentActionV2 = catchAsyncActionError(
  ({ loanRoleId, userId }) =>
    async (dispatch, getState) => {
      const { applicationId } = selectDealFromApplication(getState());

      const { data } = await applicationApi.createLoanRoleAssignment({
        applicationId,
        loanRoleId,
        userId,
        pendingChange: { isPendingCreate: true },
      });

      return data;
    },
);

// DEV-4826: reassign an already-staffed loan role to a new user via the dedicated facade endpoint
// (PUT application/{id}/loanRoleAssignments → AddPendingChange). userId is the current assignee.
export const updateLoanRoleAssignmentActionV2 = catchAsyncActionError(
  ({ loanRoleId, userId, newUserId }) =>
    async (dispatch, getState) => {
      const { applicationId } = selectDealFromApplication(getState());

      const { data } = await applicationApi.updateLoanRoleAssignment({
        applicationId,
        loanRoleId,
        userId,
        pendingChange: { newUserId },
      });

      return data;
    },
);
